import _ from 'lodash';
import R from 'ramda';
import getChangeRequestsGroup from './getChangeRequestsGroup';
import { getMemberByUserId, commpareObjectArray } from '../../../../utils';

function getDealChangeRequests(
  block,
  dealChanges,
  members,
  deal,
  agreement,
  dealUsers
) {
  let blockChangeRequests = [];
  const allChangeRequests = [];
  let changeRequests = [];
  let changeRequests2 = [];
  const accepts = [];
  const accepts2 = [];

  if (block && dealChanges) {
    if (block.name === 'Cure; Remedies' && agreement.type === 'premium') {
      let blockChangeRequests2 = [];

      dealChanges.forEach((dealChange) => {
        const changes = JSON.parse(dealChange.changes);
        if (
          dealChange.user !== deal.user &&
          dealChange.type === 'change-request-contract-block' &&
          changes &&
          changes.contract_block &&
          ((_.has(changes.contract_block, 'changes') &&
            changes.contract_block.changes !== null) ||
            !_.has(changes.contract_block, 'changes'))
        ) {
          const member = getMemberByUserId(dealChange.user, members);
          const user = member && member.user_info ? member.user_info : null;

          if (parseInt(changes.contract_block.id, 10) === block.id) {
            if (changes.contract_block.accept === true) {
              accepts.push({
                user: user,
              });
            } else {
              blockChangeRequests.push({
                changes: {
                  field1: changes.contract_block.changes.field1,
                  field3: changes.contract_block.changes.field3,
                },
                user: user,
              });
            }

            if (changes.contract_block.accept2 === true) {
              accepts2.push({
                user: user,
              });
            } else {
              blockChangeRequests2.push({
                changes: {
                  field2: changes.contract_block.changes.field2,
                },
                user: user,
              });
            }
          }
        }
      });

      changeRequests = getChangeRequestsGroup(blockChangeRequests);
      changeRequests2 = getChangeRequestsGroup(blockChangeRequests2);
    } else if (block.name === 'Services') {
      let blockChangeRequests2 = [];

      dealChanges.forEach((dealChange) => {
        const changes = JSON.parse(dealChange.changes);
        if (
          dealChange.user !== deal.user &&
          dealChange.type === 'change-request-contract-block' &&
          changes &&
          changes.contract_block &&
          ((_.has(changes.contract_block, 'changes') &&
            changes.contract_block.changes !== null) ||
            !_.has(changes.contract_block, 'changes'))
        ) {
          const member = getMemberByUserId(dealChange.user, members);
          const user = member && member.user_info ? member.user_info : null;

          if (parseInt(changes.contract_block.id, 10) === block.id) {
            if (changes.contract_block.accept === true) {
              accepts.push({
                user: user,
              });
            } else {
              blockChangeRequests.push({
                changes: {
                  producer: changes.contract_block.changes.producer,
                },
                user: user,
              });
            }

            if (changes.contract_block.accept2 === true) {
              accepts2.push({
                user: user,
              });
            } else {
              blockChangeRequests2.push({
                changes: {
                  engineering: changes.contract_block.changes.engineering,
                  mixing: changes.contract_block.changes.mixing,
                  production: changes.contract_block.changes.production,
                  masters: changes.contract_block.changes.masters,
                  artistName: changes.contract_block.changes.artistName,
                },
                user: user,
              });
            }
          }
        }
      });

      changeRequests = getChangeRequestsGroup(blockChangeRequests);
      changeRequests2 = getChangeRequestsGroup(blockChangeRequests2);
    } else if (block.name === 'Ownership') {
      let blockChangeRequests2 = [];

      dealChanges.forEach((dealChange) => {
        const changes = JSON.parse(dealChange.changes);
        if (
          dealChange.user !== deal.user &&
          dealChange.type === 'change-request-contract-block' &&
          changes &&
          changes.contract_block &&
          ((_.has(changes.contract_block, 'changes') &&
            changes.contract_block.changes !== null) ||
            !_.has(changes.contract_block, 'changes'))
        ) {
          const member = getMemberByUserId(dealChange.user, members);
          const user = member && member.user_info ? member.user_info : null;

          if (parseInt(changes.contract_block.id, 10) === block.id) {
            if (changes.contract_block.accept === true) {
              accepts.push({
                user: user,
              });
            } else {
              blockChangeRequests.push({
                changes: {
                  composition: changes.contract_block.changes.composition,
                },
                user: user,
              });
            }

            if (changes.contract_block.accept2 === true) {
              accepts2.push({
                user: user,
              });
            } else {
              blockChangeRequests2.push({
                changes: {
                  consent: changes.contract_block.changes.consent,
                },
                user: user,
              });
            }
          }
        }
      });

      changeRequests = getChangeRequestsGroup(blockChangeRequests);
      changeRequests2 = getChangeRequestsGroup(blockChangeRequests2);
    } else {
      dealChanges.forEach((dealChange) => {
        const changes = JSON.parse(dealChange.changes);

        if (
          dealChange.user !== deal.user &&
          dealChange.type === 'change-request-contract-block' &&
          changes &&
          changes.contract_block &&
          ((_.has(changes.contract_block, 'changes') &&
            changes.contract_block.changes !== null) ||
            !_.has(changes.contract_block, 'changes'))
        ) {
          const member = getMemberByUserId(dealChange.user, members);
          const user = member && member.user_info ? member.user_info : null;

          if (changes.contract_block.accept === true) {
            if (parseInt(changes.contract_block.id, 10) === block.id) {
              accepts.push({
                user: user,
              });
            }
          } else {
            allChangeRequests.push({
              id: changes.contract_block.id,
              changes: changes.contract_block.changes,
              user: user,
            });

            if (parseInt(changes.contract_block.id, 10) === block.id) {
              blockChangeRequests.push({
                changes: changes.contract_block.changes,
                user: user,
              });
            }
          }
        }
      });

      changeRequests = getChangeRequestsGroup(blockChangeRequests);
    }
  }

  if (block.name === 'Overview') {
    if (
      deal &&
      deal.agreement &&
      deal.agreement_info &&
      changeRequests &&
      changeRequests.length > 0
    ) {
      const agreementWorks = deal.agreement_info.works;
      const work = agreementWorks.find((work) => work.user === deal.user);
      const originalOwnership =
        work &&
        work.work_ownership_info.map((info) => {
          return {
            role_ids: info.role_ids,
            ownership_type: info.ownership_type,
            percentage: parseInt(info.percentage, 10),
            id: info.id,
          };
        });

      const origin = _.orderBy(originalOwnership, [(item) => item.id], ['asc']);
      const filteredReqest = _.filter(changeRequests, (change) =>
        _.isMatch(
          _.orderBy(change.changes, [(item) => item.id], ['asc']),
          origin
        )
      );
      filteredReqest.forEach((item) => {
        accepts.push({ user: item.users[0] });
      });
      changeRequests = _.filter(
        changeRequests,
        (change) =>
          !_.isMatch(
            _.orderBy(change.changes, [(item) => item.id], ['asc']),
            origin
          )
      );
    }
  } else if (block.name === 'Publishers') {
    if (changeRequests.length > 0 && dealUsers.length > 0) {
      const newChangeRequests = [];

      changeRequests.forEach((info) => {
        const dealUser = R.find(
          R.whereEq({ user: info.users[0].id, type: 'member' })
        )(dealUsers);

        const originalPublishers =
          dealUser &&
          dealUser.publishers.map((item) => {
            return {
              publisher_name: item.publisher_name,
              publisher_share: parseInt(item.publisher_share, 10),
              society: item.society,
              user: item.user,
            };
          });
        const changedPublishers = info.changes.publishers.map((item) => {
          return {
            publisher_name: item.publisher_name,
            publisher_share: parseInt(item.publisher_share, 10),
            society: item.society,
            user: item.userId,
          };
        });

        if (
          originalPublishers &&
          commpareObjectArray(originalPublishers, changedPublishers)
        ) {
          accepts.push({ user: info.users[0] });
        } else {
          newChangeRequests.push(info);
        }
      });
      changeRequests = [...newChangeRequests];
    }
  }

  return {
    changeRequests,
    allChangeRequests,
    accepts,
    changeRequests2,
    accepts2,
  };
}

export default getDealChangeRequests;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getDealChangeRequests.js